// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__1Ud1J","toolsContainer":"styles_toolsContainer__reNTW","toolWrapper":"styles_toolWrapper__2U3nE","iconSize":"styles_iconSize__1_021"};